function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import { gray100, gray600, primary600, teal400, white } from '../theme/colors';
import { fontSerif } from '../theme/fonts';
import { size14, size18, size24, size30, size36, size48, size64, size96, size144 } from '../theme/scale';
const AVATAR_VARIANTS = {
  gray: {
    color: gray600,
    background: gray100,
    'border-color': gray100
  },
  teal: {
    color: white,
    background: teal400,
    'border-color': teal400
  },
  primary: {
    color: white,
    background: primary600,
    'border-color': primary600
  }
};
const AVATAR_SIZES = {
  xxs: {
    height: size30,
    width: size30,
    'font-size': size14
  },
  xs: {
    height: size48,
    width: size48,
    'font-size': size18
  },
  sm: {
    height: size64,
    width: size64,
    'font-size': size24
  },
  md: {
    height: size96,
    width: size96,
    'font-size': size36
  },
  lg: {
    height: size144,
    width: size144,
    'font-size': size48
  }
};
const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: ${fontSerif};
  background: transparent;
  border-radius: 50%;
  line-height: 1;
  overflow: hidden;
  ${({
  showBorder
}) => showBorder && 'border: 1px solid;'}
  ${({
  variant
}) => ({
  ...AVATAR_VARIANTS[variant]
})}
  ${({
  size
}) => ({
  ...AVATAR_SIZES[size]
})}
`;
const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const getInitials = name => {
  const regex = new RegExp(/(\b[a-zA-Z])[a-zA-Z]*?/g);
  const [firstInitial, lastInitial] = name.match(regex);
  return `${firstInitial}${lastInitial}`;
};
const InitialsAvatar = ({
  name
}) => /*#__PURE__*/React.createElement("span", null, name && getInitials(name));
const ImageAvatar = ({
  src,
  name
}) => /*#__PURE__*/React.createElement(Image, {
  alt: name,
  src: src
});
export const Avatar = ({
  name,
  src,
  variant = 'gray',
  size = 'sm',
  showBorder = false,
  ...props
}) => /*#__PURE__*/React.createElement(Wrapper, _extends({
  variant,
  size,
  showBorder
}, props), src ? /*#__PURE__*/React.createElement(ImageAvatar, {
  src,
  name
}) : /*#__PURE__*/React.createElement(InitialsAvatar, {
  name
}));
export default Avatar;
//# sourceMappingURL=index.js.map